import React from "react"
// import { createControlledLayer } from "react-leaflet/types/LayersControl"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Form,
  Container,
  Label,
  Input,
  FormGroup,
  Button
} from "reactstrap"

//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb"

// import Select from "react-select"

import PromoFormMerchant from "../../components/MerchantComponents/PromoFormMerchant"

const MerchantCreateCode = () => {

  return (
    <React.Fragment>
          <PromoFormMerchant/>
    </React.Fragment>
  )
}

export default MerchantCreateCode;
